import { isNil, padStart } from 'lodash'
import { getDuration } from './DateUtil'
import { STATUS_TICKETS, STATUS_TICKETS_ID_AND_LABEL } from 'common/constants/Constants'

const PASTEL_COLOR = {
    blue: '#3355FF',
    green: '#4CAF50',
    yellow: '#FFD500',
    orange: '#FF9800',
    red: '#F44336',
    redLight: '#ff8e8e',
    redDark: '#c62828',
    white: '#FFFFFF',
    grey: '#a8a8a8',
    greyDark: '#666',
}

const POLES_COLORS = {
    SUPPORT: '#3498db',
    PROD: '#f56f27',
    DEV: '#2ecc71',
    PROJET: '#c27c0e',
    COMMERCE: '#1abc9c',
    RH: '#9b59b6',
    ADMIN: '#F44336',
}

const getColorDueDate = (date, defaultColor = '#fff') => {
    const nbDays = getDuration(undefined, date)
    if (nbDays <= 0) return PASTEL_COLOR.red
    if (nbDays <= 7) return PASTEL_COLOR.orange
    return defaultColor
}

const hexToRgb = hex => {
    if (!hex) {
        return
    }
    const rgb = hex.substring(1).match(/.{2}/g).map(x => parseInt(x, 16))
    return `rgb(${rgb.join(',')})`
}

const rgbToHex = rgb => {
    if (!rgb) {
        return
    }
    const rgbPart = rgb.replace('rgb(', '').replace(')', '').split(',')
    const hexPart = rgbPart.map(c => {
        const hex = Number(c).toString(16)
        return padStart(hex, 3, '0')
    }).join('')
    return `#${hexPart}`
}

const getContrast = hexColor => {
    if (!hexColor) {
        return
    }
    const color = hexColor.slice(1)

    const formattedHexColor = color.length === 3 ? color.split('').map(hex => `${hex}${hex}`).join('') : color

    const r = parseInt(formattedHexColor.substr(0, 2), 16)
    const g = parseInt(formattedHexColor.substr(2, 2), 16)
    const b = parseInt(formattedHexColor.substr(4, 2), 16)

    return ((r * 299) + (g * 587) + (b * 114)) / 1000
}

const getTextColorByHexColor = hexColor => {
    if (!hexColor) {
        return 'black'
    }
    const yiq = getContrast(hexColor)

    return (yiq > 128) ? 'black' : 'white'
}

// Ticket à 100 % mais pas encore passé en « Attente validation interne » : avancement incohérent.
const isBeforeInternValidation = (statut) => {
    const statusId = STATUS_TICKETS.find(s => s.value === statut)?.id
    return !isNil(statusId) && statusId < STATUS_TICKETS_ID_AND_LABEL.ATTENTE_VALIDATION_INTERNE
}

const getColorAdv = (adv = 0, statut) => {
    const intAdv = parseInt(adv)
    if (isNaN(intAdv)) return undefined
    if (intAdv >= 100 && isBeforeInternValidation(statut)) return PASTEL_COLOR.orange
    if (intAdv >= 100) return PASTEL_COLOR.green
    if (intAdv <= 0) return undefined
    return PASTEL_COLOR.orange
}

export {
    PASTEL_COLOR,
    POLES_COLORS,
    hexToRgb,
    rgbToHex,
    getTextColorByHexColor,
    getColorAdv,
    getColorDueDate,
}
